import { render } from "./index.vue?vue&type=template&id=3257a3c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3257a3c6&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3257a3c6"]])

export default __exports__